
import { ref } from "@vue/reactivity";
import { useLoan } from "../hooks/useLoan";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { formatNumber, getAvailableCredit } from "../static/utils";
import { Loan, LoanStatus } from "../models/Loan";
import { useRouter } from "vue-router";
import { useUser } from "@/hooks/useUserInfo";
import { computed } from "@vue/runtime-core";
export default {
  setup() {
    const router = useRouter();
    const {
      amount,
      term,
      emiPlans,
      getEMIAmount,
      calculateTotalInterest,
      interestRate,
    } = useLoan({ amount: 1000 });
    const { userData } = useUser();

    const { storedValue: loanData, setValue: setLoanData } = useLocalStorage<
      Loan[]
    >("loanData", []);

    const availableCredit = getAvailableCredit(loanData.value);

    const formattedAvailableCredit = computed(() =>
      formatNumber(availableCredit)
    );
    const formattedAmount = computed(() => formatNumber(amount.value));
    const formattedEMI = computed(() =>
      formatNumber(getEMIAmount(amount.value, term.value))
    );
    const formattedTotalInterest = computed(() =>
      formatNumber(
        calculateTotalInterest({
          loanAmount: amount.value,
          term: term.value,
        })
      )
    );
    const formattedTotalEMIAmount = computed(() =>
      formatNumber(getEMIAmount(amount.value, term.value) * term.value)
    );

    const finishLoan = () => {
      const response = confirm("Are you sure to proceed with the loan?");
      if (response) {
        const loan: Loan = {
          id: Date.now(),
          amount: amount.value,
          term: term.value,
          status: LoanStatus.PendingApproval,
          user: userData.value,
          emi: getEMIAmount(amount.value, term.value),
          paidAmount: 0,
          interestRate,
        };
        setLoanData([...loanData.value, loan]).then((saved) => {
          if (saved) {
            router.push("/dashboard");
          }
        });
      }
    };
    return {
      amount,
      availableCredit,
      calculateTotalInterest,
      emiPlans,
      formattedAvailableCredit,
      formattedAmount,
      formattedEMI,
      formattedTotalInterest,
      formattedTotalEMIAmount,
      formatNumber,
      finishLoan,
      getEMIAmount,
      step: ref(1),
      term,
    };
  },
};
